import { Inject, Injectable } from '@angular/core';
import { createClient, SupabaseClient } from '@supabase/supabase-js';
import { SUPABASE_CONFIG, SupabaseConfig } from './supabase.config';

@Injectable({
  providedIn: 'root',
})
export class SupabaseCore {
  private _client: SupabaseClient;

  constructor(@Inject(SUPABASE_CONFIG) private config: SupabaseConfig) {
    this._client = createClient(
      this.config.supabaseUrl,
      this.config.supabaseKey,
      this.config.options
    );
  }

  get client(): SupabaseClient {
    return this._client;
  }
}
